import { getCookie } from '@/libs/cookie';
import store from '@/store';

export default function(e) {
  const currentNode = e.target;
  // 当前异常是由图片加载异常引起的
  if (currentNode && currentNode.tagName && currentNode.tagName.toUpperCase() === 'IMG') {
    const cookieLocale = getCookie('locale') || store.currentLocale || 'en-US';

    // 创建一个 div 替代 img
    const errorDiv = document.createElement('div');
    errorDiv.className = 'g-img-error';

    // 添加 SVG 图标
    const svgIcon = `
              <svg class="icon" style="vertical-align: middle; overflow: hidden;" 
                viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                <path d="M704.137 448.209c72.559 0 128.024-52.485 128.024-125.044 0-72.565-58.822-131.381-131.381-131.381-72.565 0-124.668 55.647-124.668 128.212 0 72.559 55.46 128.213 128.025 128.213z m0-192.256c34.561 0 64.363 29.245 64.363 64.044 0 33.254-30 63.794-64.363 63.794-35.314 0-64.012-30.29-64.012-63.794-0.001-35.299 30.406-64.044 64.012-64.044zM541.944 636.359L256.05 319.996l-128.025 98.879v93.253l128.025-95.262 192.037 223.099 93.857-3.606z m53.223 75.085"></path>
                <path d="M927.996 895.639L576.112 512.127 128.025 895.639h97.35l350.737-287.264 290.622 319.844 61.262-32.58zM63.333 63.333h897.021v64.657H63.333zM63.333 127.99h64.692v832.233H63.333z"></path>
                <path d="M128.025 895.639h769.101v64.088H128.025z"></path>
                <path d="M896.01 127.99h64.345v831.568H896.01z"></path>
              </svg>
            `;

    // 添加本地化文字
    const errorText = cookieLocale === 'zh-CN' ? '图片加载失败' : 'Image load failed';

    // 将 SVG 和文字添加到 div
    errorDiv.innerHTML = `${svgIcon}<span class="g-img-error-text">${errorText}</span>`;

    // 替换原始图片节点
    currentNode.parentNode.replaceChild(errorDiv, currentNode);
  }
}
